module.exports = __webpack_public_path__ + "static/media/icon-location.a2abaf46.svg";